import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    autenticacao: {
      autenticado: false,
      nivel: 0,
      token: '',
      nome: '',
      status: 0
    },
    usuario: {
      login: '',
      senha: '',
      persistencia: true
    },
    loading: false
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/autenticacao/index.js